import { Stack, Typography, useTheme } from "@mui/material";
import { BellOff, CalendarX } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export type EmptyTimelineVariant = "upcoming" | "recent";

interface EmptyTimelineStateProps {
	variant: EmptyTimelineVariant;
}

const ICON_SIZE = 48;

export const EmptyTimelineState: FC<EmptyTimelineStateProps> = ({
	variant,
}) => {
	const { t } = useResource();
	const theme = useTheme();

	const isUpcoming = variant === "upcoming";

	const Icon = isUpcoming ? CalendarX : BellOff;
	const message = isUpcoming
		? t(Resources.NotificationCenter.Empty.Upcoming)
		: t(Resources.NotificationCenter.Empty.Recent);

	return (
		<Stack
			height="60vh"
			justifyContent="center"
			alignItems="center"
			gap={1.6}
			padding="0 32px"
			data-testid={`notification-center-empty-${variant}`}
		>
			<Icon
				size={ICON_SIZE}
				color={theme.palette.grey[400]}
				strokeWidth={1.5}
			/>
			<Typography
				fontSize={14}
				fontWeight={500}
				color={theme.palette.grey[600]}
				textAlign="center"
			>
				{message}
			</Typography>
		</Stack>
	);
};
